import { AfterViewInit, Component, ContentChild, Input, OnChanges, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { TopHeaderDirective } from '../directives/top-header.directive';
import { BottomHeaderConfig, HeaderConfig, HeaderThemeEnum, MainHeaderConfig, MenuConfig, TopHeaderConfig } from '../../../models/header-model';
import { NbMenuItem } from '@nebular/theme';
import { latLng } from 'leaflet';

@Component({
  selector: 'ubs-header',
  templateUrl: './ubs-header-fat-alt.component.html',
  styleUrls: ['./ubs-header-fat-alt.component.scss']
})
export class UbsHeaderFatAltComponent implements OnInit,OnChanges,AfterViewInit {
  @Input() headerConfig:HeaderConfig;
  //@Input() menuItems:NbMenuItem[];
  //States
  topHeader:boolean;
  mainHeader:boolean;
  bottomHeader:boolean;
  //Configs
  mainHeaderConfig:MainHeaderConfig;
  topHeaderConfig:TopHeaderConfig;
  bottomHeaderConfig:BottomHeaderConfig;
  //Elements
  host:HTMLElement;
  navHost:HTMLElement;
  mainHeaderEl:HTMLElement;
  topHeaderEl:HTMLElement;
  bottomHeaderEl:HTMLElement;
  layoutContainer:HTMLElement;
  //Main Menu
  mainMenuConfig:MenuConfig;
  menuItems:NbMenuItem[];
  
  layoutClass = "main-only";

  /**
   * This checker is required for live editing purposes only. It is set to false initially to prevent 
   * header formatting on the OnChange method.  Header Setting happens on AfterViewInit on loan and on OnChange afterwards
   */
  headersInitailised:boolean = false;

  @ContentChild(TopHeaderDirective) content!: TopHeaderDirective;

  constructor(private readonly viewRef: ViewContainerRef) { 
    this.host = this.viewRef.element.nativeElement;
    
  }
  ngAfterViewInit(): void {
    this.navHost = this.host.closest('nav');
    this.layoutContainer = <HTMLElement>this.navHost.parentElement.nextElementSibling;
    //Set the elements
    this.mainHeaderEl = <HTMLElement>this.host.querySelector('.main-header');
    this.topHeaderEl = <HTMLElement>this.host.querySelector('.top-header');
    this.bottomHeaderEl = <HTMLElement>this.host.querySelector('.bottom-header');

    this.formatHeader("main",this.mainHeaderEl);
    this.formatHeader("top",this.topHeaderEl);
    this.formatHeader("bottom",this.bottomHeaderEl);
    this.headersInitailised = true;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["headerConfig"]){
      console.log(this.headerConfig);
      console.log(this.navHost);
      this.topHeader = this.headerConfig.topHeader;
      this.mainHeader = this.headerConfig.mainHeader;
      this.bottomHeader = this.headerConfig.bottomHeader;
      //Set the configs
      this.mainHeaderConfig = this.headerConfig.mainHeaderConfig;
      this.topHeaderConfig = this.headerConfig.topHeaderConfig;
      this.bottomHeaderConfig = this.headerConfig.bottomHeaderConfig;
      //Geth them main Menu Config
      this.mainMenuConfig = this.headerConfig.mainMenuConfig;
      this.menuItems = this.mainMenuConfig.menuItems;
      if(this.headersInitailised){
        this.formatHeader("main",this.mainHeaderEl);
        this.formatHeader("top",this.topHeaderEl);
        this.formatHeader("bottom",this.bottomHeaderEl);
      }

      //Set the elements
      /* let mainHeaderEl = <HTMLElement>this.host.querySelector('.main-header');
      let topHeaderEl = <HTMLElement>this.host.querySelector('.top-header');
      let bottomHeaderEl = <HTMLElement>this.host.querySelector('.bottom-header');

      this.formatHeader("main",mainHeaderEl);
      this.formatHeader("top",topHeaderEl);
      this.formatHeader("bottom",bottomHeaderEl) */
      




      /* if(this.mainHeaderConfig.custom != undefined && this.mainHeaderConfig.custom == true){
        
      }else{
        if(this.mainHeaderConfig.mainDark){
          console.log("setting main Dark");
          if(mainHeaderEl != null && mainHeaderEl != undefined){
            mainHeaderEl.classList.add('main-dark');
            mainHeaderEl.style.setProperty("background","");
          }

        }else{
          if(mainHeaderEl != null && mainHeaderEl != undefined){
            mainHeaderEl.classList.remove('main-dark');
            mainHeaderEl.style.background = "transparent";
          }
        }
      } */
      /**
       * Header Layout settings
       */
      if(this.bottomHeader && !this.topHeader){
        console.log("BottomOnly");
        this.host.classList.add('bottom-only');
        if(this.host.classList.contains("main-only")) this.host.classList.remove("main-only");
        if(this.host.classList.contains("top-only")) this.host.classList.remove("top-only");
        if(this.host.classList.contains("top-bottom")) this.host.classList.remove("top-bottom");
        this.setHeaderHeight("bottomOnly");
      }
      if(!this.bottomHeader && this.topHeader){
        console.log("TopOnly");
        this.host.classList.add('top-only');
        if(this.host.classList.contains("main-only")) this.host.classList.remove("main-only");
        if(this.host.classList.contains("bottom-only")) this.host.classList.remove("bottom-only");
        if(this.host.classList.contains("top-bottom")) this.host.classList.remove("top-bottom");
        this.setHeaderHeight("topOnly");
      }
      if(this.bottomHeader && this.topHeader){
        console.log("Both");
        this.host.classList.add('top-bottom');
        if(this.host.classList.contains("main-only")) this.host.classList.remove("main-only");
        if(this.host.classList.contains("top-only")) this.host.classList.remove("top-only");
        if(this.host.classList.contains("bottom-only")) this.host.classList.remove("bottom-only");
        this.setHeaderHeight("topBottom");
      }
      if(!this.bottomHeader && !this.topHeader){
        console.log("main-only");
        this.host.classList.add('main-only');
        if(this.host.classList.contains("top-bottom")) this.host.classList.remove("top-bottom");
        if(this.host.classList.contains("top-only")) this.host.classList.remove("top-only");
        if(this.host.classList.contains("bottom-only")) this.host.classList.remove("bottom-only");
        this.setHeaderHeight("mainOnly");
      }
      /* if(this.mainHeaderConfig.containsMainNav){
        this.bottomHeader = false;
      } */
      


    }
    

  }

  setHeaderHeight(layoutOption:string):void{
    let adjustHeight = 0;
    //let mainHost = <HTMLElement>this.host.querySelector('.main-header');
    if(this.mainHeaderEl != undefined && this.mainHeaderEl != null){
      let hostHeight = this.mainHeaderEl.offsetHeight;
      let topHost;
      let bottomHost;
      setTimeout(() => {
        switch (layoutOption) {
          case "bottomOnly":
            if(this.bottomHeaderEl == null || this.bottomHeaderEl == undefined){
              this.bottomHeaderEl = <HTMLElement>this.host.querySelector('.bottom-header');
            }
            //bottomHost = <HTMLElement>this.host.querySelector('.bottom-header');
            adjustHeight = hostHeight+this.bottomHeaderEl.offsetHeight;
            break;
          case "topOnly":
            //topHost = <HTMLElement>this.host.querySelector('.top-header');
            if(this.topHeaderEl == null || this.topHeaderEl == undefined){
              this.topHeaderEl = <HTMLElement>this.host.querySelector('.top-header');
            }
            adjustHeight = hostHeight+this.topHeaderEl.offsetHeight;
            break;
          case "topBottom":
            if(this.bottomHeaderEl == null || this.bottomHeaderEl == undefined){
              this.bottomHeaderEl = <HTMLElement>this.host.querySelector('.bottom-header');
            }
            if(this.topHeaderEl == null || this.topHeaderEl == undefined){
              this.topHeaderEl = <HTMLElement>this.host.querySelector('.top-header');
            }
            /* topHost = <HTMLElement>this.host.querySelector('.top-header');
            bottomHost = <HTMLElement>this.host.querySelector('.bottom-header'); */
            adjustHeight = hostHeight+this.topHeaderEl.offsetHeight+this.bottomHeaderEl.offsetHeight
            break;
          default:
            adjustHeight = this.mainHeaderEl.offsetHeight;
            break;
        }
        this.layoutContainer.style.setProperty('--header-height',adjustHeight+"px");
        console.log(adjustHeight);
      }, 10);
    }
  }
  /**
   * 
   * @param type Header section - main|top|bottom
   * @param headerEl HTMLElement for the section
   * For each section the following is effected
   * First Check for a custom config
   * If custom is true use the background attribute
   * Else use the mainDark class
   */
  formatHeader(type:string,headerEl:HTMLElement){
    //console.log({type:type,headerEl:headerEl})
    if(headerEl != null){
      switch(type){
        case "main":
          console.log({UbsHeaderFatAltComponent:this.mainHeaderConfig});
          let headerTheme:HeaderThemeEnum = this.mainHeaderConfig.themeEnum;
          this.setHeaderTheme("main",headerTheme,this.mainHeaderConfig,headerEl);
          break;
        case "top":
          let topheaderTheme = this.topHeaderConfig.themeEnum;
          this.setHeaderTheme("top",topheaderTheme,this.topHeaderConfig,headerEl);
          break;
        case "bottom":
          let bottomheaderTheme = this.topHeaderConfig.themeEnum;
          this.setHeaderTheme("bottom",bottomheaderTheme,this.bottomHeaderConfig,headerEl);
          break;
      }
    }
    
   
  }

  setHeaderTheme(configType:string,themeEnum:HeaderThemeEnum,headerConfig:MainHeaderConfig | TopHeaderConfig | BottomHeaderConfig,headerEl:HTMLElement){
    console.log(themeEnum)
    switch (themeEnum) {
      case HeaderThemeEnum.DEFAULT:
        this.removeClasses(headerEl,['main-dark','main-custom']);
        headerEl.classList.add('main-default');
        break;
      case HeaderThemeEnum.CUSTOM:
        headerEl.classList.add('main-custom');
        this.removeClasses(headerEl,['main-dark','main-default']);
        break;
      case HeaderThemeEnum.DARK:
        headerEl.classList.add('main-dark');
        this.removeClasses(headerEl,['main-custom','main-default'])
        break;
      default:
        console.log("Holy shit")
        break;
    }
  }

  removeClasses(el:HTMLElement,classes:string[]){
    classes.forEach(cls => {
      if(el.classList.contains(cls)){
        el.classList.remove(cls)
      }
    })
  }

}
